/*
 drawerMenu

 This component represents the report drawer menu.

 Parameters:
 -- dataPromise: a promise that returns the menuGroups for the drawer menu to display.
 -- onMenuItemClick: a function that should be called when a menu item is clicked.
 */

import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';

ko.components.register('drawerMenu', {
    viewModel: drawerMenu,
    template: {
        element: 'drawer-menu-template'
    }
});

export function drawerMenu(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof drawerMenu)
        return data;

    self.menuGroups = ko.observableArray([]);
    self.filteredMenuGroups = ko.observableArray([]);
    self.dataPromise = data.dataPromise;
    self.filterString = ko.observable("");

    //Subscribe to updates of the filterString
    self.filterString.subscribe(function (filterString) {

        self.filteredMenuGroups([]);

        _.forEach(self.menuGroups(), function (grp) {
            if (grp.filterItems(filterString) > 0) {
                self.filteredMenuGroups.push(grp);
            }
        });
    });

    var init = function () {

        if (!_.isNullOrUndefined(self.dataPromise)) {

            self.dataPromise.apply(null, self.args).then(
                function (results) {

                    self.menuGroups([]);
                    self.filteredMenuGroups([]);

                    _.forEach(results, function (group) {

                        //Expand favorites by default
                        group.isExpanded = group.folderName === "Favorites";

                        group.onMenuItemClick = data.onMenuItemClick;
                        var grp = new menuGroup(group);
                        self.menuGroups.push(grp);
                    });

                    self.filteredMenuGroups(self.menuGroups())
                },
                function (errorResult) {
                });
        }
    }

    init();
}


function menuGroup(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof menuGroup)
        return data;

    self.title = ko.observable(data.folderName);
    self.items = ko.observableArray([]);
    self.filteredItems = ko.observableArray([]);
    self.isExpanded = ko.observable(data.isExpanded);

    self.toggle = function (item, event) {
        self.isExpanded(!self.isExpanded())
    }

    //Filter the list of items and return the count of filtered items
    self.filterItems = function (filterString) {

        var filter = _.defaultIfNullOrUndefined(filterString, "").toLowerCase();

        //Get the filtered items
        var items = _.filter(self.items(), function (item) {

            //An empty string filter returns all items
            if (filter && filter.length == 0)
                return true;

            return item.text().toLowerCase().indexOf(filter) >= 0;
        });

        self.filteredItems(items);

        return items.length;
    }

    var init = function () {

        self.items([]);
        self.filteredItems([]);

        if (!_.isNullOrUndefined(data.reports)) {

            _.forEach(data.reports, function (item) {
                item.onMenuItemClick = data.onMenuItemClick;
                item.folderName = self.title();
                self.items.push(new menuGroupItem(item));
            });

            self.filteredItems(self.items());
        }
    }

    init();
}

function menuGroupItem(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof menuGroupItem)
        return data;

    self.onDragEndReportMenuItem = (_, event) => data.onDragEndReportMenuItem?.(_, event);
    self.onDragOverReportMenuItem = (_, event) => data.onDragOverReportMenuItem?.(_, event);
    self.onDropReportMenuItem = (_, event) => data.onDropReportMenuItem?.(_, event);

    self.element = ko.observable(null);
    self.value = ko.observable(data.reportId);
    self.text = ko.observable(data.title);
    self.folderName = ko.observable(data.folderName);
    self.isReportOwner = ko.observable(data.isReportOwner);
    self.onMenuItemClick = ko.observable(data.onMenuItemClick);

    const elementSubscription = self.element.subscribe(el => {
        el.addEventListener('dragstart', event => data.onDragStartReportMenuItem?.(event));

        elementSubscription.dispose();
    });
    
    self.itemClick = function (item, event) {
        if (!_.isNullOrUndefined(self.onMenuItemClick)) {
            self.onMenuItemClick().call(null, item.value());
        }
    }
}


/*
 accordion

 Custom Knockout bindingHandler for rendering an accordion

*/
ko.bindingHandlers.accordion = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        // This will be called when the binding is first applied to an element
        // Set up any initial state, event handlers, etc. here
        // $(element).next().hide();
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        // This will be called once when the binding is first applied to an element,
        // and again whenever any observables/computeds that are accessed change
        // Update the DOM element based on the supplied values here.

        var $menu = $(element).next();

        var isExpanded = ko.toJS(valueAccessor());

        if (isExpanded) {
            $menu.slideDown(400);
        }
        else {
            $menu.slideUp(300);
        }
    }
};
